import type { MarketConfig } from '../../types';

export const academyUsConfig = {
  slug: 'aca-us-fusa-machinery',
  label: 'Academy USA FuSa Machinery',
  country: 'US',
  language: 'en',
  siteSection: 'ACA_US',
  cms: 'AzureSWA',
  title: 'Functional Safety Training for Machinery | TÜV SÜD Academy USA',
  description:
    'Functional safety training for machinery and industrial systems aligned with ISO 13849, IEC 62061, IEC 61508, and IEC 61511.',
  themeColor: '#0046ad',
  ogImage: 'https://mango-grass-0099f4103.6.azurestaticapps.net/favicon.png',
  ogImageAlt: 'TÜV SÜD Academy USA Functional Safety Training for Machinery landing page preview image',
  twitterCard: 'summary_large_image',
  robots: 'noindex,nofollow',
} satisfies MarketConfig;
